module.exports = __webpack_public_path__ + "img/cancel.e3741d9b.svg";